const isValidCuit = (cuit) => {
  const factors = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
  let accumulate = 0

  for (let i = 0; i < factors.length; i++) {
    accumulate += parseInt(cuit.charAt(i)) * factors[i]
  }
  let checkDigit = 11 - (accumulate % 11)
  if (checkDigit === 11) {
    checkDigit = 0
  }
  return parseInt(cuit.charAt(10)) === checkDigit
}

const cuitValidator = (cuit) => {
  if (cuit.length === 1 && !isNaN(Number(cuit))) {
    return true
  }
  if (cuit.length < 11 || cuit.length > 11 || isNaN(Number(cuit))) {
    return false
  }

  return isValidCuit(cuit)
}
export default cuitValidator
